import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-feature-trial-lock-modal',
  templateUrl: './feature-trial-lock-modal.component.html',
  styleUrls: ['./feature-trial-lock-modal.component.scss']
})
export class FeatureTrialLockModalComponent implements OnInit {

  constructor(public modalRef: MDBModalRef, public router: Router) { }

  ngOnInit(): void {
  }

}
